module.exports = __webpack_public_path__ + "img/clap.942a9aff.svg";